import React from "react";
import {
  IonApp,
  IonHeader,
  IonContent,
  IonGrid,
  IonCol,
  IonRow,
} from "@ionic/react";

import AboutMe from "./Components/AboutMe";
import MyToolbar from "./Components/MyToolbar";

import NotableProjects from "./Components/NotableProjects";
import WorkExperience from "./Components/WorkExperience";
import Writings from "./Components/Writings";
import "./App.css";

function App() {
  return (
    <IonApp>
      <IonHeader className="ion-header ion-text-right ion-padding">
        <MyToolbar />
      </IonHeader>
      <IonContent className="ion-padding">
        <IonGrid>
          <IonRow></IonRow>

          <IonRow>
            <IonCol size="3"></IonCol>

            <IonCol size="6">
              <AboutMe />
              <WorkExperience />
              <NotableProjects />
              <Writings />
            </IonCol>

            <IonCol size="2"></IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonApp>
  );
}

export default App;
